// extracted by mini-css-extract-plugin
export default {"title":"o_ONWId0rWyKqsopruyZ","inputsBlock":"YCV3jqKD88DpWWcoEVRo"};